import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import COLORS from '@/constants/colors';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { useDeliveryAddressViewController } from './DeliveryAddressViewController';
import { NewAddress } from './NewAddress/NewAddress';

export function DeliveryAddress() {
  const { uiState, actions } = useDeliveryAddressViewController();

  return (
    <Stack
      spacing={'12px'}
      mt={{ xs: '25px', md: '40px' }}
      p={{ xs: '16px', md: '0px' }}
    >
      <FormSectionTitle
        title={'Dirección de mi negocio'}
        subtitle="Esta es la dirección a la que se entregará tu pedido"
      />
      <BasicContainer
        content={
          <Box
            p={'16px'}
            display={'inline-flex'}
            flexDirection={'column'}
            gap={'16px'}
            width={'100%'}
          >
            <Grid container columnSpacing={'20px'} rowGap={'14px'}>
              {uiState.deliveryAddresses.map((item) => (
                <Grid key={item.id} item xs={12} md={6}>
                  <BasicContainer
                    content={
                      <Box
                        display={'flex'}
                        m={'16px'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        gap={'8px'}
                      >
                        <Stack flexGrow={1}>
                          <Typography
                            sx={{
                              color: COLORS.gray_700,
                              fontWeight: 500,
                              fontSize: '14px',
                            }}
                          >
                            {item.title}
                          </Typography>
                          <Typography
                            sx={{
                              color: COLORS.gray_600,
                              fontWeight: 400,
                              fontSize: '14px',
                            }}
                          >
                            {item.subtitle}
                          </Typography>
                        </Stack>
                        <Button
                          variant="outlined"
                          sx={buttonSx}
                          onClick={() => actions.onClickedFavorite(item.id)}
                        >
                          {item.isFavorite ? (
                            <StarOutlinedIcon />
                          ) : (
                            <StarOutlineOutlinedIcon />
                          )}
                        </Button>
                        <Button
                          variant="outlined"
                          sx={buttonSx}
                          onClick={() => actions.onClickedDelete(item.id)}
                        >
                          <DeleteOutlineOutlinedIcon />
                        </Button>
                      </Box>
                    }
                  />
                </Grid>
              ))}
            </Grid>
            {uiState.deliveryAddresses.length === 0 && (
              <Typography>Sin direcciones</Typography>
            )}
            {!uiState.addingNewAddress && (
              <Button
                sx={{
                  fontWeight: 600,
                  color: COLORS.gray_600,
                  fontSize: '14px',
                  width: 'fit-content',
                }}
                startIcon={<AddOutlinedIcon />}
                onClick={actions.onClickedNewAddress}
              >
                <Typography>Agregar direccion</Typography>
              </Button>
            )}

            {uiState.addingNewAddress && (
              <NewAddress onAddressChanged={actions.onAddressChanged} />
            )}
          </Box>
        }
        footer={
          uiState.addingNewAddress ? (
            <Stack
              sx={{ flexDirection: 'row-reverse', p: '16px' }}
              gap={'16px'}
            >
              <Button
                variant="contained"
                disabled={uiState.saveDisabled}
                onClick={actions.onClickedSave}
              >
                Guardar cambios
              </Button>
              <Button variant="contained" onClick={actions.onClickedCancel}>
                Cancelar
              </Button>
            </Stack>
          ) : undefined
        }
      />
    </Stack>
  );
}

const buttonSx = { minWidth: 0, width: '30px', height: '30px' };
